angular.
module('moebiusProadapt')
    .directive('mbsQrv', ['$rootScope', '$timeout', '$uibModal', 'promiseTracker', 'mbsEtiService', 'mbsUser', 'growl', 'mbsParticipantService', 'moment', function ($rootScope, $timeout, $uibModal, promiseTracker, mbsEtiService, mbsUser, growl, mbsParticipantService, moment) {
        function link(scope, element, attrs)
        {
            // -- en mode build
            scope.isBuildMode = false;

            if (_.isUndefined(scope.buildMode)) {
                scope.buildMode   = 'preview';
            }
            else if (scope.buildMode === 'edit_def' || scope.buildMode === 'edit_def_and_template') {
                scope.isBuildMode = true;
            }


            scope.constants    = scope.$root.constants;
            scope.eti          = mbsEtiService.getCurrentEti();
            scope.visite       = mbsEtiService.getCurrentVisite();
            scope.questionnaire= scope.eti.etudedefArray.questionnairesList[scope.questionnaireVisite.questionnaire_key];
            scope.tracker      = promiseTracker('tracker');


            scope.saveQuestionVisiteDate = function () {
                // scope.participant.saveQuestionnaireVisite(scope.questionnaireVisite.key);
                scope.participant.saveQuestionsVisites([scope.questionnaireVisite.questionVisiteDate.id]).then(function() {

                });
            };

            scope.emptyQuestionVisiteRaisonNonRempli = function () {
                scope.participant.setValue(scope.questionnaireVisite.questionVisiteRaisonNonRempli, null);
                scope.participant.saveQuestionsVisites([scope.questionnaireVisite.questionVisiteRaisonNonRempli.id]).then(function() {

                });
            };

            var mbsDynamicTemplateUrl;
            if (scope.isBuildMode) {
                mbsDynamicTemplateUrl = 'assets/templates/etude-def/build-questionnaire.html';
            } else {
                mbsDynamicTemplateUrl = 'assets/templates/generic_templates/questionnaire.html';
            }

            if (scope.questionnaire && scope.questionnaire.templateUrl) {
                mbsDynamicTemplateUrl = scope.questionnaire.templateUrl;
            }

            scope.getContentUrl = function() {
                return mbsDynamicTemplateUrl ;
            };

            scope.showQrPrecisions = function(questionnaire) {
                //préparation du scope de la modale
                var local_scope = scope.$new();
                local_scope.questionnaire = questionnaire;

                var path = 'assets/templates/etude-def/help/' + questionnaire.help_url + '.html';

                //modale de présentation de l'aide
                scope.modalInstance = $uibModal.open({
                    templateUrl: path,
                    backdrop: 'static',
                    size: 'lg',
                    scope: local_scope
                });

            };

            scope.openModalRaisonNonRempli = function () {
                var scopeModal = scope.$new();

                scopeModal.questionnaireVisite = scope.questionnaireVisite;
                //Create modal instance
                var modalInstance = $uibModal.open({
                    templateUrl: 'assets/templates/generic_templates/modal/modal-raison-non-rempli.html',
                    controller: 'ctrlQvRaisonNonRempli',
                    windowClass: 'md-dialog',
                    scope: scopeModal,
                    backdrop: 'static',
                    keyboard: false
                });

            };
            scope.userHasRight = function () {
                return $rootScope.userHasRight([$rootScope.rights.ADMIN, $rootScope.rights.ACCES_DOCUMENTATION_SCORE]);
            };
            scope.openModalScoreDetails = function () {
                if (!$rootScope.userHasRight([$rootScope.rights.ADMIN, $rootScope.rights.ACCES_DOCUMENTATION_SCORE])) {
                    return;
                }

                var scopeModal = scope.$new();

                var QMScoreKeyCrossEtude = scope.eti.etudedefArray.questionsMeresList[scope.questionnaireVisite.questionVisiteScore.question_mere_key].key_cross_etude ;

                scopeModal.documentationScore = {
                    nomQuestionnaire: scope.questionnaireVisite.name,
                    cheminRelatifImage: "scores_images/" + QMScoreKeyCrossEtude + ".png"
                };
                //Create modal instance
                var modalInstance = $uibModal.open({
                    templateUrl: 'assets/templates/generic_templates/modal/modal-documentation-score.html',
                    //controller: 'ctrlQvRaisonNonRempli',
                    windowClass: 'lg-dialog',
                    scope: scopeModal,
                    backdrop: 'static',
                });
            };
        }

        // -- PROADAPT
        // -- un controller qui permet aux directives QV enfants de faire remonter des events
        function controller($scope) {
            var vm      = this;
            var directiveScope  = $scope;
            vm.getMyQuestionnaireVisite = function() {
                return directiveScope.questionnaireVisite;
            };
            vm.isLastQuestionVisiteOfQuestionnaire = function(questionVisite, callingElement) {
                var qvContainerElement = callingElement.parents('div.questionnaire-content');

                directiveScope.questionnaireVisite.updateIsDirty();

                return callingElement.is(qvContainerElement.find('mbs-qv').last());
            };
            vm.questionVisiteStatusChanged = function(questionVisite, callingElement) {
                var qvContainerElement = callingElement.parents('div.questionnaire-content');

                directiveScope.questionnaireVisite.updateIsDirty();

                // auto save if all manu and visible questions have been answered (liveProgression=100)
                // can't use liveProgression here because it is evaluated later
                // nb total questions = all manu and visible questions - (raison_non_remplie + score if exists)
                var total       =  _.filter(directiveScope.questionnaireVisite.questionsVisitesOrderedIds, function(qvKey) {
                    var questionVisite = directiveScope.eti.etudedefArray.questionsVisitesList[qvKey];
                    return questionVisite.overwritePriority === "manu" && questionVisite.localAttributes.visible === true
                        //doivent ne pas être ND
                        && (directiveScope.questionnaireVisite.questionVisiteRaisonNonRempli === null
                            || typeof directiveScope.questionnaireVisite.questionVisiteRaisonNonRempli.id === "undefined"
                            || questionVisite.id !== directiveScope.questionnaireVisite.questionVisiteRaisonNonRempli.id
                            )
                        //doivent ne pas être un score
                        && (directiveScope.questionnaireVisite.questionVisiteScore === null
                            || typeof directiveScope.questionnaireVisite.questionVisiteScore.id === "undefined"
                            || questionVisite.id !== directiveScope.questionnaireVisite.questionVisiteScore.id
                        );
                });
                var answered = _.filter(total, function(qvKey) {
                    var questionVisite = directiveScope.eti.etudedefArray.questionsVisitesList[qvKey];
                    return questionVisite.stateAnswerAndSave === 'ANSWERED_DIRTY' || questionVisite.stateAnswerAndSave === 'ANSWERED_SAVED';
                });
                if (answered && answered.length>0) {
                    answered = answered.length;
                }
                if (total && total.length>0) {
                    total = total.length;
                }
                // console.log('questionVisiteStatusChanged', answered,total,directiveScope.questionnaireVisite, directiveScope.questionnaireVisite.liveProgression, directiveScope.questionnaireVisite.questionsVisitesOrderedIds);

                if(directiveScope.questionnaireVisite.isDirty && total === answered ) {
                    mbsParticipantService.getCurrentParticipant().saveQuestionnaireVisite(directiveScope.questionnaireVisite.key);
                } /* else {
                    console.log("NON : Toutes les questions ne sont pas répondues : " + answered + " / " + total);
                }*/


            };
            vm.onDeleteElementFromQrv = function(item) {
                directiveScope.mbsOnDeleteElement({'$element': item});
            };
            vm.onAddElementToQmFromQrv = function(questionMere) {
                directiveScope.mbsOnAddElementToQm({'$questionMere': questionMere});
            };
            vm.onMoveElementOfQmFromQrv = function(questionVisite, questionMere) {
                directiveScope.mbsOnMoveElementOfQm({'$questionVisite': questionVisite, '$questionMere': questionMere});
            };
        }

        return {
            restrict: 'E',
            scope: {
                questionnaireVisite:    '=mbsQuestionnaireVisite',
                participant:            '=mbsParticipant',
                buildMode:              '=?buildMode',
                filterQuestion:         '&mbsQrvFilterQuestion',
                mbsOnDeleteQuestionVisite: '&',
                mbsOnMoveQuestionMereOfQr: '&',
                mbsOnAddQvToQrv: '&',
                mbsOnCreateQmForQr: '&',
                mbsOnDeleteElement: '&',
                mbsOnAddElementToQm: '&',
                mbsOnMoveElementOfQm: '&',
            },
            link: link,
            controller: controller,
            controllerAs: 'vm',
            // templateUrl:'assets/templates/generic_templates/form/field/mbs_form_field_template.html',
            template: '<div ng-include="getContentUrl()"></div>'
        }
    }])


    .directive('mbsQv', ['$rootScope', '$timeout', 'mbsEtiService', 'growl', 'promiseTracker', 'mbsUser', 'filterFilter', '$http', '$filter', '$uibModal', '$window', '$q', 'moment', function ($rootScope, $timeout, mbsEtiService, growl, promiseTracker, mbsUser, filterFilter, $http, $filter, $uibModal, $window, $q, moment) {

        function userCanReadOnly(scope){
            scope.readOnly   = true;
            var inputs = angular.element(document.querySelectorAll(".questionnaire-header input, .questionnaire-header button"));
            var dateAndSave = angular.element(document.querySelectorAll(".questionnaire-header-saver-icon"));
            var topBarActions = angular.element(document.querySelectorAll(".top-bar-actions button"));
            var timeline = angular.element(document.querySelectorAll(".timeline_container"));
            var questionHeader = angular.element(document.querySelectorAll(".question-header button, .question-content button"));
            inputs.attr('disabled', true);
            topBarActions.attr('disabled', true);
            questionHeader.attr('disabled', true);
            dateAndSave.remove();
            timeline.remove();
            console.log("userCanReadOnly");
        }

        function link(scope, element, attrs, $ctrl)
        {

            // -- ----------------------
            // -- Initialisation directive QuestionVisite
            // -- ----------------------

            // -- en mode build
            scope.isBuildMode = false;
            if (_.isUndefined(scope.buildMode)) {
                scope.buildMode   = 'preview';
            }
            else if (scope.buildMode === 'edit_def' || scope.buildMode === 'edit_def_and_template') {
                scope.isBuildMode = true;
            }

            //readOnly, used to only display given answer
            if (_.isUndefined(scope.readOnly)) {
                scope.readOnly   = false;
            }
            if(!$rootScope.userHasRight([$rootScope.rights.ADMIN, $rootScope.rights.ACCES_ECRITURE_UN_CENTRE, $rootScope.rights.ACCES_ECRITURE_TOUT_CENTRE])
                || scope.participant.is_locked
                || (!$rootScope.userHasRight([$rootScope.rights.ADMIN]) && scope.participant.centre_id != $rootScope.constants.user.centre_id)
            ){
                userCanReadOnly(scope);
            }

            //console.log(scope.readOnly);

            scope.constants                         = scope.$root.constants;
            scope.mbsUser                           = scope.$root.mbsUser;
            scope.isDirectSaveMode                  = scope.$root.globalParams.isDirectSaveMode;
            scope.isRemoteCallbackMode              = scope.$root.globalParams.isRemoteCallbackMode;
            scope.eti                               = mbsEtiService.getCurrentEti();
            scope.questionMere                      = scope.eti.etudedefArray.questionsMeresList[scope.questionVisite.question_mere_key];

            scope.directSaveIfEditEditableAnswer    = false;

            scope.questionVisite.stateAnswerAndSave = null;

            // -- other reference to get from parents directives (QuestionnaireVisite)
            scope.visite                                    = null;
            scope.questionnaireVisiteKeyToUpdateProgress    = null;
            scope.tableTracker = promiseTracker('tableTracker');


            scope.grades = {};
            _.each(scope.constants.grade_toxicite_types.VALUES_TO_DISPLAY,function(value,key){
                scope.grades[key]=({id:key,label:value,desc:scope.constants.grade_toxicite_types.VALUES_TO_DESCRIPTION[key]});
            });
            scope.actions = {};
            _.each(scope.constants.action_toxicite_types.VALUES_TO_DISPLAY,function(value,key){
                scope.actions[key]=({id:key,label:value});
            });
            scope.evolutions= {};
            _.each(scope.constants.evolution_toxicite_types.VALUES_TO_DISPLAY,function(value,key){
                scope.evolutions[key]=({id:key,label:value});
            });
            scope.gradesChir = {};
            _.each(scope.constants.grade_complication_chirurgicale_types.VALUES_TO_DISPLAY,function(value,key){
                scope.gradesChir[key]=({id:key,label:value});
            });
            scope.examensRadiologiquesList = {} ;
            _.each(scope.constants.examens_radiologiques_list.VALUES_TO_DISPLAY,function(value, key){
                scope.examensRadiologiquesList[key] = {key:key,label:value};
            });
            scope.evaluationMaladieList = [] ;
            _.each(scope.constants.evaluation_maladie_list.VALUES_TO_DISPLAY,function(value, key){
                scope.evaluationMaladieList[key] = {key:key,label:value};
            });

            scope.getOnlyStoppedTraitements = function(o) {
                return (o.action === "maintenir" && o.isDeleted === true) || (o.action === "stop" && o.isDeleted === false);
            };

            // -- to handle autosave when reaching end of form
            // -- récupération de clés nécessaires
            if ($ctrl && $ctrl.getMyQuestionnaireVisite) {
                scope.visite                                 = scope.eti.etudedefArray.visitesList[$ctrl.getMyQuestionnaireVisite().visite_key];
                scope.questionnaireVisiteKeyToUpdateProgress = $ctrl.getMyQuestionnaireVisite().key;
                scope.questionnaireVisite = $ctrl.getMyQuestionnaireVisite();
            }


            var mbsDynamicTemplateUrl, extract;
            if (scope.isBuildMode) {

                // -- todo, ajouter un cas pour 'assets/templates/etude-def/linked_table/build_question_template.html';

                mbsDynamicTemplateUrl = 'assets/templates/etude-def/form/field/build_question_template.html';
            } else {
                mbsDynamicTemplateUrl = scope.questionMere.questionTemplateUrl;
            }
            // -- formula callbacks
            scope.questionVisite.previousValue       = null;


            // USE TOP CTRL SCOPE METHOD
            scope.deleteElement = function(item) {
                $ctrl.onDeleteElementFromQrv(item);
            };
            scope.addElementToQm = function(questionMere) {
                $ctrl.onAddElementToQmFromQrv(questionMere);
            };
            scope.moveElementOfQm = function(questionVisite, questionMere) {
                $ctrl.onMoveElementOfQmFromQrv(questionVisite, questionMere);
            };

            // -- ----------------------
            // -- Specific Widget init
            // -- ----------------------

            // -- if NUMBER
            // -- ----------------

            if (scope.questionMere.dataType === scope.constants.data_types.NAMES_TO_VALUES.NUMBER) {
                scope.decimalNb       = 1;
                scope.decimalStep     = '0.1';
                scope.decimalPattern  = "^-?[0-9]*(\.[0-9]{0,1})?$"; //une seule décimale
                scope.decimalPlaceholder  = "0.0";
                if (scope.questionMere.inputOptions && scope.questionMere.inputOptions.decimalNumber) {
                    if (scope.questionMere.inputOptions.decimalNumber === 2) {
                        scope.decimalNb = 2;
                        scope.decimalStep     = '0.01';
                        scope.decimalPattern  = "^-?[0-9]*(\.[0-9]{0,2})?$";
                        scope.decimalPlaceholder  = "0.00";
                    }
                    if (scope.questionMere.inputOptions.decimalNumber === 3) {
                        scope.decimalNb = 3;
                        scope.decimalStep     = '0.001';
                        scope.decimalPattern  = "^-?[0-9]*(\.[0-9]{0,3})?$";
                        scope.decimalPlaceholder  = "0.000";
                    }
                }
                scope.onSelect = function($event) {
                    var elValue = $event.target.value;
/*
                    console.log('onSelect element ' + $event.target.selectionStart + ' ' + $event.target.selectionEnd);
                    console.log('onSelect value ' + elValue);
                    console.log($event.target);*/
                };

                scope.onKeyPressed = function($event)
                {
                    var elValue = $event.target.value;
                    var regex = new RegExp(scope.decimalPattern);
                    var key   = String.fromCharCode(!$event.charCode ? $event.which : $event.charCode);
                    var valueWouldBeValid = '';

                    // -- si le texte de l'input est non vide et sélectionné
                    // -- alors la keypress doit remplacer le contenu
                    // -- donc on doit tester la validité de la nouvelle chaîne tappée
                    if ($window.getSelection() && $window.getSelection().toString() && elValue && $window.getSelection().toString() === elValue ) {

                        valueWouldBeValid = key;

                    }
                    // -- sinon, on est ent rain d'ajouter du texte à l'input
                    // -- donc on test la valeur présente concaténée à la nouvelle key pressed
                    else {

                        if (elValue) {
                            if (elValue.length >0 ) {
                                valueWouldBeValid += elValue;
                            }
                        }

                        valueWouldBeValid += key;
                    }


                    if (regex.test(valueWouldBeValid))
                    {
                        console.info('test passed ' + valueWouldBeValid);

                    } else {
                        console.info('test not passed ' + valueWouldBeValid);
                        $event.preventDefault();
                        return false;
                    }
                };

                scope.onPasted = function($event)
                {
                    var regex = new RegExp(scope.decimalPattern);
                    var paste = $event.originalEvent.clipboardData.getData('text/plain');
                    var valueWouldBeValid = scope.participant.getValue(scope.questionVisite) + paste;
                    if(regex.test(valueWouldBeValid))
                    {
                        $event.preventDefault();
                        growl.warning("You can't copy this text because it contains not allowed character for this input, please type your value manually.", {ttl: 5000});
                        return false;
                    }
                }
            }

            // -- if MULTIPLE_CHECKBOX by idx
            // -- ----------------
            scope.multiCheckboxOption       = [];
            var shouldWatch = true;

            if (scope.questionMere.inputType === scope.constants.input_types.NAMES_TO_VALUES.MULTIPLE_CHECKBOX) {
                var initialData = scope.participant.getValue(scope.questionVisite);
                scope.multiCheckboxOption = scope.questionVisite.localAttributes.dynamicDropDown;
                _.each(scope.multiCheckboxOption, function(item) {
                    if (initialData && initialData.indexOf(item.id) > -1) {
                        item.selected = true;
                    } else {
                        item.selected = false;
                    }
                });

                // Helper method to get selected fruits
                scope.selectedOptions = function selectedOptions() {
                    return filterFilter(scope.multiCheckboxOption, { selected: true });
                };

                // Watch fruits for changes
                scope.$watch('multiCheckboxOption|filter:{selected:true}', function (nv) {
                    // flag to prevent 2 concurrent calls when deleting answer :
                    // flag is set to false when setting all option values to false to prevent watcher from triggering
                    // flag is set back to ture after receiving response of onBlurWillSave
                    if(shouldWatch) {
                        var newMultipleValue = nv.map(function (option) {
                            return option.id;
                        });

                        if (newMultipleValue && newMultipleValue.length === 0) {
                            newMultipleValue = null;
                        }
                        scope.participant.setValue(scope.questionVisite, newMultipleValue);
                        scope.onBlur();
                    }
                }, true);
            }

            // -- if SLIDE_BY_IDX
            // -- ----------------

            scope.sliderOptions = {};
            scope.sliderOptionsOptions = {};
            scope.tmpValueSliderRange = null;
            scope.isTmpValueInitBySliderRange = false;
            scope.onChangeTmpValueSliderRange = null;

            if (scope.questionMere.inputType === scope.constants.input_types.NAMES_TO_VALUES.RATE_SLIDER) {

                // -- Since Input Range automatically set a value, anyway even if the input is untouched
                // -- 1. Then we work on a tmpValue to render the slider
                scope.tmpValueSliderRange = -1 ;

                scope.onChangeTmpValueSliderRange = function() {
                    // console.log('Called : ' + this.tmpValueSliderRange + ' is scope.isTmpValueInitBySliderRange:' + scope.isTmpValueInitBySliderRange);
                    // -- 1. Attention, il y a un premier appel à ng-change hors interaction utilisateur
                    // -- 1. contrairement à ce que dit la doc angularjs. Ce booléean est là pour gérer ce 1er appel
                    if (!scope.isTmpValueInitBySliderRange) {
                        scope.isTmpValueInitBySliderRange = true;
                    }
                    else {
                        scope.participant.setValue(scope.questionVisite, this.tmpValueSliderRange);
                        scope.onBlur();
                    }
                };

                scope.sliderOptions = {
                    orientation: 'horizontal',
                    // min: 0,
                    // max: 255,
                    // min: scope.questionMere.inputOptions.min,
                    // max: scope.questionMere.inputOptions.max,
                    range: 'min',
                    tick: true,
                    tip: true
                    // ,
                    // step: 1
                    // change: refreshSwatch,
                    // slide: refreshSwatch
                };
                //determine min, max and step from value list
                scope.sliderOptionsOptions.labels = [];
                for(var i=scope.questionMere.inputOptions.min; i<=scope.questionMere.inputOptions.max; i++) {
                    scope.sliderOptionsOptions.labels.push(i);
                }
                scope.sliderOptionsOptions.min  = scope.questionMere.inputOptions.min;
                scope.sliderOptionsOptions.max  = scope.questionMere.inputOptions.max;
                scope.sliderOptionsOptions.step = 1;

                scope.sliderOptionsOptions.total = parseInt( (parseInt(scope.sliderOptionsOptions.max) - parseInt(scope.sliderOptionsOptions.min)) /parseInt(scope.sliderOptionsOptions.step));
                scope.sliderOptionsOptions.left  = {};
                for (var j = scope.sliderOptionsOptions.total; j >= 0; j--) {

                    scope.sliderOptionsOptions.left[j] = ((j / scope.sliderOptionsOptions.total) * 100) + '%';
                    // scope.sliderOptionsOptions.labels.push(j);
                }


            } else if (scope.questionMere.inputType === scope.constants.input_types.NAMES_TO_VALUES.SLIDER_BY_IDX) {
                // -- Since Input Range automatically set a value, anyway even if the input is untouched
                // -- 1. Then we work on a tmpValue to render the slider
                scope.tmpValueSliderRange = 0;

                scope.onChangeTmpValueSliderRange = function() {
                    // console.log('Called : ' + this.tmpValueSliderRange + ' is scope.isTmpValueInitBySliderRange:' + scope.isTmpValueInitBySliderRange);
                    // -- 1. Attention, il y a un premier appel à ng-change hors interaction utilisateur
                    // -- 1. contrairement à ce que dit la doc angularjs. Ce booléean est là pour gérer ce 1er appel
                    if (!scope.isTmpValueInitBySliderRange) {
                        scope.isTmpValueInitBySliderRange = true;
                    }
                    else {
                        scope.participant.setValue(scope.questionVisite, this.tmpValueSliderRange);
                        scope.onBlur();
                    }
                };

                scope.sliderOptions = {
                    orientation: 'horizontal',
                    // min: 0,
                    // max: 255,
                    // min: scope.questionMere.inputOptions.min,
                    // max: scope.questionMere.inputOptions.max,
                    range: 'min',
                    tick: true,
                    tip: true
                    // ,
                    // step: 1
                    // change: refreshSwatch,
                    // slide: refreshSwatch
                };
                //determine min, max and step from value list
                var valueList = scope.questionVisite.localAttributes.dynamicDropDown;
                scope.sliderOptionsOptions.min  = valueList[0].id;
                scope.sliderOptionsOptions.max  = valueList[valueList.length-1].id;
                scope.sliderOptionsOptions.step = 1;


                scope.sliderOptionsOptions.labels = [];
                for(var k = 0 ; k < valueList.length ; k=k+scope.sliderOptionsOptions.step) {
                    scope.sliderOptionsOptions.labels.push(valueList[k].name);
                }

                scope.sliderOptionsOptions.total = parseInt( (parseInt(scope.sliderOptionsOptions.max) - parseInt(scope.sliderOptionsOptions.min)) /parseInt(scope.sliderOptionsOptions.step));
                scope.sliderOptionsOptions.left  = {};
                for (var m = scope.sliderOptionsOptions.total; m >= 0; m--) {

                    scope.sliderOptionsOptions.left[m] = ((m / scope.sliderOptionsOptions.total) * 100) + '%';
                    // scope.sliderOptionsOptions.labels.push(m);
                }
            }

            // -- if DATE
            // -- ----------------

            if (scope.questionMere.inputType === scope.constants.input_types.NAMES_TO_VALUES.DATE) {
                if(scope.questionMere.inputOptions && scope.questionMere.inputOptions.maxDate==="today"){
                    scope.dateOptions={maxDate:new Date()};
                }
            }

            // -- ----------------------
            // -- Gestion de l'état répondu / save
            // -- ----------------------
            var _evaluateStateAnswerAndSave = function(questionVisite) {
                if (null === scope.participant.getValue(questionVisite)
                    || (
                        // -- champ multiple vide
                        scope.participant.getValue(questionVisite) instanceof Array
                        && scope.participant.getValue(questionVisite).length === 0
                    )
                ) {
                    questionVisite.stateAnswerAndSave = 'NOT_ANSWERED';
                } else {
                    if (questionVisite.isDirty) {
                        questionVisite.stateAnswerAndSave = 'ANSWERED_DIRTY';
                    } else {
                        questionVisite.stateAnswerAndSave = 'ANSWERED_SAVED';
                    }
                }
                // gestion pour ND
                if(scope.participant.participantValuesByQuestionVisiteId[questionVisite.id].nd){
                    questionVisite.stateAnswerAndSave = 'ANSWERED_SAVED';
                }


                // -- @todo, garder cela SSI on sauvegarde les erreurs de validation
                questionVisite.validationErrors = scope.participant.participantValuesByQuestionVisiteId[questionVisite.id].validationErrors;
            };

            _evaluateStateAnswerAndSave(scope.questionVisite);


            // -- ----------------------
            // -- Méthodes exposées par la directive
            // -- ----------------------

            scope.getContentUrl = function() {
                if(mbsDynamicTemplateUrl.includes("linked_table")){
                    if(!$rootScope.userHasRight([$rootScope.rights.ADMIN, $rootScope.rights.ACCES_ECRITURE_UN_CENTRE, $rootScope.rights.ACCES_ECRITURE_TOUT_CENTRE])
                        || scope.participant.is_locked
                        || (!$rootScope.userHasRight([$rootScope.rights.ADMIN]) && scope.participant.centre_id != $rootScope.constants.user.centre_id)
                    ){
                        userCanReadOnly(scope);
                    }
                }
                return mbsDynamicTemplateUrl ;
            };

            /**
             * Méthode du scope de la directive
             * appelable depuis les templates
             */
            scope.editEditableAnswer = function() {
                scope.questionVisite.stateAnswerAndSave = 'ANSWERED_DIRTY';
                scope.questionVisite.cast(scope.participant);
                scope.directSaveIfEditEditableAnswer = true;

                // -- specifique for input range
                scope.tmpValueSliderRange = scope.participant.getValue(scope.questionVisite);
                scope.isTmpValueInitBySliderRange       = true;
            };

            scope.deleteEditableAnswer = function(){
                if(confirm('Etes-vous sûr de vouloir supprimer la réponse à cette question?')) {
                    var answer = null;
                    if (scope.questionMere.inputType === scope.constants.input_types.NAMES_TO_VALUES.MULTIPLE_CHECKBOX) {
                        shouldWatch = false;
                        //reset all values to false
                        // scope.multiCheckboxOption = scope.questionVisite.localAttributes.dynamicDropDown;
                        _.each(scope.questionVisite.localAttributes.dynamicDropDown, function(item) {
                            item.selected = false;
                        });
                    }else{
                        scope.isTmpValueInitBySliderRange = false;
                        scope.tmpValueSliderRange = null;
                    }
                    scope.participant.setValue(scope.questionVisite, answer);
                    // set nd to false
                    scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].nd = 0;
                    scope.onBlurWillSave(scope.visite, false, scope.questionVisite.id);
                }
            };

            scope.cancelNdForEditableAnswer = function(){
                // set nd to true
                scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].nd = 0;
                scope.onBlurWillSave(scope.visite, false, scope.questionVisite.id);
            };

            scope.setNdForEditableAnswer = function(){
                // set nd to true
                scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].nd = 1 ;
                scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].manu = null;
                scope.onBlurWillSave(scope.visite, false, scope.questionVisite.id);
            };

            scope.openModalShowHistory = function () {
                var scopeModal = scope.$new();

                // scopeModal
                scopeModal.history = scope.participant.historicParticipantValuesByQuestionVisiteId[scope.questionVisite.id];
                //Create modal instance
                var modalInstance = $uibModal.open({
                    templateUrl: 'assets/templates/generic_templates/modal/modal-show-history.html',
                    controller: 'ctrlQvShowHistory',
                    windowClass: 'md-dialog',
                    scope: scopeModal,
                    backdrop: 'static',
                });

            };

            // -- get the last value when a field is changed
            scope.onFocus = function() {
                // --- on ne set pas la previousValue au focus, on la setté à l'init de la directive
                // --- do nothing
                return;
            };

            var isEqualPreviousNewValue = function (inputType, previousValue, newValue) {
                if (inputType === scope.constants.input_types.NAMES_TO_VALUES.MULTIPLE_CHECKBOX) {
                    return _.isEqual(_.sortBy(previousValue), _.sortBy(newValue));
                }
                else {
                    return previousValue === newValue;
                }
            };

            /**
             * Test si la date du QuestionnaireVisite est déjà settée (ou settée à ne sait pas)
             * si oui, retourne une fake promise (le traitement suivant pourra continuer)
             * sinon, ouverture d'une modale, jusqu'à confirmation par l'utilisateur
             */
            scope.openModalSetFormCompletionDate = function() {

                var qvDateDeLaVisite = scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__DATE_DE_LA_VISITE');
                var qvDateRemplissageQrv = scope.questionnaireVisite.questionVisiteDate;

                // -- Test si la date du QuestionnaireVisite est déjà settée (ou settée à ne sait pas)
                if (scope.participant.getValue(qvDateRemplissageQrv)) {
                    // -- retourne une fake promise (le traitement suivant pourra continuer)
                    var deferredFakePromise = $q.defer();
                    deferredFakePromise.resolve();
                    return deferredFakePromise.promise;
                }
                var scopeModal = scope.$new();

                scope.participant.setValue(qvDateRemplissageQrv, scope.participant.getValue(qvDateDeLaVisite));

                scopeModal.paramModal = {
                    title: 'Date de remplissage',
                    questionnaireName: scope.questionnaireVisite.name,
                    dateRemplissageQrvValue: scope.participant.getValue(qvDateRemplissageQrv),
                    hasDateDeLaVisite: (scope.participant.getValue(qvDateDeLaVisite) && scope.participant.getValue(qvDateDeLaVisite) instanceof Date),
                    dateDeLaVisite: scope.participant.getValue(qvDateDeLaVisite)
                };

                scopeModal.saveDatesRemplissages = function() {
                    // -- comme c'est fait, la modale est backdrop et ne peut être quittée sans résultat
                    var modifiedQv = [];

                    var paramModal = this.paramModal;

                    if (paramModal) {
                        paramModal.dateRemplissageQrvValue.setHours(12,0,0,0);
                        scope.participant.setValue(qvDateRemplissageQrv, paramModal.dateRemplissageQrvValue);

                        modifiedQv.push(qvDateRemplissageQrv);

                        // -- si visite n'avait pas de date, on a dû en recevoir une
                        if (!paramModal.hasDateDeLaVisite) {
                            paramModal.dateDeLaVisite.setHours(12,0,0,0);
                            scope.participant.setValue(qvDateDeLaVisite, paramModal.dateDeLaVisite);

                            modifiedQv.push(qvDateDeLaVisite);
                        }
                    }

                    this.$close(modifiedQv);
                };


                var modalInstance = $uibModal.open({
                    templateUrl: 'assets/templates/etude/modal_set-form-completion-date.html',
                    windowClass: 'md-dialog',
                    scope: scopeModal,
                    backdrop: 'static',
                    keyboard: false,
                    controller: function ($scope, $document) {

                        var EVENT_TYPES = "keydown keypress"
                        function eventHandler(event) {
                            if (event.which === 13) {
                                // -- champs obligatoire
                                if (!$scope.paramModal.dateRemplissageQrvValue || !$scope.paramModal.dateDeLaVisite) {
                                    return;
                                }
                                else {
                                    $scope.saveDatesRemplissages();
                                }
                            }
                        }
                        $document.bind(EVENT_TYPES, eventHandler);
                        $scope.$on('$destroy', function () {
                            $document.unbind(EVENT_TYPES, eventHandler);
                        })
                    }
                });

                var promise = modalInstance.result;

                // scope.tracker.addPromise(promise);

                promise.then(function (modifiedQv) {
                //
                //
                //     // -- retourne une fake promise (le traitement suivant pourra continuer en mode then, avec le résultat qu'on veut faire passer
                    var deferredFakePromise = $q.defer();
                    deferredFakePromise.resolve(modifiedQv);
                    return deferredFakePromise.promise;
                });

                return promise;
            };

            scope.onBlur = function()
            {
                var currentValue        = null;
                var remotePromises;

                // -- reset value to null to make easy evaluation on other process
                if(scope.participant.getValue(scope.questionVisite) === '') {
                    scope.participant.setValue(scope.questionVisite, null);
                }

                currentValue = scope.participant.getValue(scope.questionVisite);
                console.log('___ onBlur ' +  scope.questionMere.inputType + ' previousValue:' + scope.questionVisite.previousValue + ' currentValue:' + currentValue);

                if (false === isEqualPreviousNewValue(scope.questionMere.inputType, scope.questionVisite.previousValue, currentValue))
                {

                    // -- si au niveau global on enregistre à chaque modif
                    // -- OU, si on modifie une question déjà enregistrée une première fois
                    if (scope.isDirectSaveMode || scope.directSaveIfEditEditableAnswer) {

                        if(scope.questionnaireVisite.questionVisiteDate !== null) {
                            // ...
                            scope.openModalSetFormCompletionDate().then(function (returnedModifedQvToSave) {

                                if (returnedModifedQvToSave && returnedModifedQvToSave.length > 0) {
                                    scope.onBlurWillSaveMultiple(scope.visite, currentValue, scope.questionVisite, returnedModifedQvToSave);
                                }
                                else {
                                    scope.onBlurWillSave(scope.visite, currentValue, scope.questionVisite.id);
                                }

                            });

                        } else {
                            growl.error('Erreur : Absence de question Date de remplissage pour ce questionnaire', { ttl: 5000 });
                        }
                    }
                    else {

                        // -- si jamais on édite la dernière question, on annule defait le remoteCallWithoutSaving
                        if (scope.isRemoteCallbackMode && !$ctrl.isLastQuestionVisiteOfQuestionnaire(scope.questionVisite, element)) {
                            if(scope.questionnaireVisite.questionVisiteDate !== null) {
                                // ...
                                scope.openModalSetFormCompletionDate().then(function (returnedModifedQvToSave) {

                                    //Remote call back after date modale to prevent bug (when validating date before end of notify, the date was not taken into account)
                                    // Remote call back
                                    remotePromises = scope.questionVisite.notification.remote.notify(scope.questionVisite, scope.visite, scope.participant, currentValue, scope.questionVisite.previousValue);

                                    if (returnedModifedQvToSave && returnedModifedQvToSave.length > 0) {
                                        scope.onBlurWillNotSaveMultiple(scope.visite, currentValue, scope.questionVisite, returnedModifedQvToSave);
                                    }
                                    else {

                                        // Then Local callback when ended
                                        remotePromises.finally(function(responses) {
                                            scope.onBlurWillNotSave(scope.visite, currentValue);
                                        });

                                    }
                                });
                            } else {
                                growl.error('Erreur : Absence de question Date de remplissage pour ce questionnaire', { ttl: 5000 });
                            }
                        }
                        else {
                            if(scope.questionnaireVisite.questionVisiteDate !== null) {
                                // ...
                                scope.openModalSetFormCompletionDate().then(function (returnedModifedQvToSave) {


                                    if (returnedModifedQvToSave && returnedModifedQvToSave.length > 0) {
                                        scope.onBlurWillNotSaveMultiple(scope.visite, currentValue, scope.questionVisite, returnedModifedQvToSave);
                                    }
                                    else {
                                        scope.onBlurWillNotSave(scope.visite, currentValue);
                                    }



                                });
                            } else {
                                growl.error('Erreur : Absence de question Date de remplissage pour ce questionnaire', { ttl: 5000 });
                            }
                        }
                    }


                }
                else {
                    // --- actuellement ce cas n'est pas vraiment togglé car, quant il y a une réponse, et qu'on la change, le onBlurWillSave est automatique
                    scope.questionVisite.isDirty = false;
                    _evaluateStateAnswerAndSave(scope.questionVisite);
                    // -- PROADAPT
                    // -- Call Parent Directive
                    if ($ctrl && $ctrl.questionVisiteStatusChanged) {
                        // -- notify parent QRV Directive if exist
                        $ctrl.questionVisiteStatusChanged(scope.questionVisite, element);
                    }
                }
            };

            scope.onBlurWillNotSave = function(visite, currentValue) {
                // -- local cascade via notify
                scope.questionVisite.notification.local.notify(scope.questionVisite, visite, scope.participant, currentValue, scope.questionVisite.previousValue);

                scope.questionVisite.isDirty = true;

                if (currentValue !== null) {
                    $timeout(_evaluateStateAnswerAndSave(scope.questionVisite));
                }

                // --- console.log('___ onBlurWillNotSave ' +  scope.questionMere.inputType + ' previousValue:' + scope.questionVisite.previousValue + ' changed to:' + scope.participant.getValue(scope.questionVisite);
                // --- DO NOT UPDATE previous until saved !! scope.questionVisite.previousValue = scope.participant.getValue(scope.questionVisite);

                // -- PROADAPT
                // -- Call Parent Directive
                if ($ctrl && $ctrl.questionVisiteStatusChanged) {
                    // -- notify parent QRV Directive if exist
                    $ctrl.questionVisiteStatusChanged(scope.questionVisite, element);
                }
            };



            scope.onBlurWillNotSaveMultiple = function(visite, currentValueEditedQv, editedQv, extraQuestionsVisitesToSave) {

                // -- 1 -  on gère l'édition de la QV liée à la directive

                // -- local cascade via notify
                editedQv.notification.local.notify(editedQv, visite, scope.participant, currentValueEditedQv, editedQv.previousValue);
                editedQv.isDirty = true;

                // -- 2 - on ajoute les extracQv
                _.each(extraQuestionsVisitesToSave, function(extraQuestionVisite) {
                    extraQuestionVisite.notification.local.notify(extraQuestionVisite, visite, scope.participant, scope.participant.getValue(extraQuestionVisite) , extraQuestionVisite.previousValue);
                    extraQuestionVisite.isDirty = true;
                });

                if (currentValueEditedQv !== null) {
                    $timeout(function() {
                        // -- état la QV de la directive
                        _evaluateStateAnswerAndSave(editedQv);

                        // -- état des extra QV
                        _.each(extraQuestionsVisitesToSave, function(extraQuestionVisite) {
                            _evaluateStateAnswerAndSave(extraQuestionVisite);
                        });
                    });                }

                // --- console.log('___ onBlurWillNotSave ' +  scope.questionMere.inputType + ' previousValue:' + scope.questionVisite.previousValue + ' changed to:' + scope.participant.scope.participant.getValue(scope.questionVisite));
                // --- DO NOT UPDATE previous until saved !! scope.questionVisite.previousValue = scope.participant.scope.participant.getValue(scope.questionVisite);

                // -- PROADAPT
                // -- Call Parent Directive
                if ($ctrl && $ctrl.questionVisiteStatusChanged) {
                    // -- notify parent QRV Directive if exist
                    $ctrl.questionVisiteStatusChanged(editedQv, element);
                    _.each(extraQuestionsVisitesToSave, function(extraQuestionVisite) {
                        $ctrl.questionVisiteStatusChanged(extraQuestionVisite, element);
                    });
                }
            };

            scope.onBlurWillSave = function(visite, currentValue, questionVisiteId) {
                // -- local cascade via notify
                scope.questionVisite.notification.local.notify(scope.questionVisite, visite, scope.participant, currentValue, scope.questionVisite.previousValue);

                scope.questionVisite.isDirty = true;

                // -- PROADAPT
                // -- On pourrait optionnellement activer le save direct sur une question
                // -- auquel cas, il conviendrait peut-$être de faire passer la QRV key pour updater le QRV contenant
                scope.participant.saveQuestionsVisites([questionVisiteId], scope.questionnaireVisiteKeyToUpdateProgress).then(function() {
                    $timeout(_evaluateStateAnswerAndSave(scope.questionVisite));
                    if(!shouldWatch) {
                        shouldWatch=true;
                    }

                    // --- Read previous / current
                    console.log('___ onBlurWillSave ' +  scope.questionMere.inputType + ' previousValue:' + scope.questionVisite.previousValue + ' changed to:' + scope.participant.getValue(scope.questionVisite));

                });

            };


            scope.onBlurWillSaveMultiple = function(visite, currentValueEditedQv, editedQv, extraQuestionsVisitesToSave) {

                var questionsVisitesIds = [];

                // -- 1 - on gère l'édition de la QV liée à la directive
                editedQv.notification.local.notify(editedQv, visite, scope.participant, currentValueEditedQv, editedQv.previousValue);
                editedQv.isDirty = true;
                questionsVisitesIds.push(editedQv.id);

                // -- 2 - on ajoute les extracQv
                _.each(extraQuestionsVisitesToSave, function(extraQuestionVisite) {
                    extraQuestionVisite.notification.local.notify(extraQuestionVisite, visite, scope.participant, scope.participant.getValue(extraQuestionVisite) , extraQuestionVisite.previousValue);
                    extraQuestionVisite.isDirty = true;
                    questionsVisitesIds.push(extraQuestionVisite.id);
                });

                scope.participant.saveQuestionsVisites(questionsVisitesIds, scope.questionnaireVisiteKeyToUpdateProgress).then(function() {
                    $timeout(function() {
                        // -- état la QV de la directive
                        _evaluateStateAnswerAndSave(editedQv);

                        // -- état des extra QV
                        _.each(extraQuestionsVisitesToSave, function(extraQuestionVisite) {
                            _evaluateStateAnswerAndSave(extraQuestionVisite);
                        });
                    });
                    if(!shouldWatch) {
                        shouldWatch=true;
                    }

                    // --- Read previous / current
                    console.log('___ onBlurWillSaveMultiple ');

                });

            };

            // ---------------------------------------------------------------- //
            // ---- METHODE POUR LES QUESTIONS LINKED TABLES ------------------ //
            // ---------------------------------------------------------------- //


            // ---- SPECIFIC PAR LINKED_TABLE  ------------------ //
            // --                                                 //

            /* DELETION */

            var deleteElementInArrayOfParticipant = function(attribute, data) {
                var index = _.findIndex(scope.participant[attribute][scope.questionVisite.id], { id: data.id });
                scope.participant[attribute][scope.questionVisite.id].splice(index, 1);
                if (scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].auto && scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].auto > 0) {
                    // -- 210223_6: LIve update de la valeur Auto
                    scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].auto--;
                }
                scope.updateProgessOfLinkedTableQuestionnaire(attribute);
            };

            scope.deleteTraitement = function(p) {
                $http.delete('participant-traitement/' + p.id, {params:p})
                    .then(function(response) {
                        deleteElementInArrayOfParticipant("participantTraitementsByQuestionVisiteId", response.data);
                        scope.checkAACAAP(p)
                    }).catch(function (e) {
                    console.log(e);
                })
            };
            scope.deletePriseencharge = function(p) {
                $http.delete('participant-priseencharge/' + p.id, {params:p})
                    .then(function(response) {
                        deleteElementInArrayOfParticipant("participantPriseenchargesByQuestionVisiteId", response.data);
                    }).catch(function (e) {
                    console.log(e);
                })
            };
            scope.deleteEicomplication = function(p) {
                $http.delete('participant-eicomplication/' + p.id, {params:p})
                    .then(function(response) {
                        deleteElementInArrayOfParticipant("participantEicomplicationsByQuestionVisiteId", response.data);
                    }).catch(function (e) {
                    console.log(e);
                })
            };

            scope.deleteEvaluationMaladie = function(p) {
                $http.delete('participant-evaluationmaladie/' + p.id, {params:p})
                    .then(function(response) {
                        deleteElementInArrayOfParticipant("participantEvaluationMaladieByQuestionVisiteId", response.data);
                    }).catch(function (e) {
                    console.log(e);
                })
            };

            scope.deletePecTherapeutique = function(p) {
                $http.delete('participant-pectherapeutique/' + p.id, {params:p})
                    .then(function(response) {
                        deleteElementInArrayOfParticipant("participantPecTherapeutiqueByQuestionVisiteId", response.data);
                    }).catch(function (e) {
                    console.log(e);
                })
            };

            /* EDITION */

            var editElementInArrayOfParticipant = function(attribute, data) {
                // inutile car on le fait plus bas : angular.extend(p, response.data);

                var idxEditedItem = _.findIndex(scope.participant[attribute][scope.questionVisite.id],{id: data.id});
                scope.participant[attribute][scope.questionVisite.id][idxEditedItem] = data;
            };

            var prepModificationsTherapeutiques = function(editedItem) {
                if(editedItem.modifications_therapeutiques_resultat_changement) {
                    editedItem.subtype = "traitement_modif_therapeutique" ;
                } else {
                    editedItem.subtype = "traitement_initial" ;
                }

                //nettoyage des champs à affichage conditionnel
               /* if(editedItem.modifications_therapeutiques_resultat_changement === 1) {
                    delete editedItem.dose ;
                    delete editedItem.posologie_matin ;
                    delete editedItem.posologie_midi ;
                    delete editedItem.posologie_soir ;*/
                    /*editedItem.is_en_cours = 0 ;
                    editedItem.date_fin = editedItem.modifications_therapeutiques_date_changement ;*/
               /* }*/
                /*if(editedItem.modifications_therapeutiques_resultat_changement === 3) {
                    editedItem.date_debut = editedItem.modifications_therapeutiques_date_changement ;
                }
                if(editedItem.modifications_therapeutiques_resultat_changement === 2
                    || editedItem.modifications_therapeutiques_resultat_changement === 3) {
                    editedItem.is_en_cours = 1 ;
                }*/
                if (!editedItem.is_pnr) {
                    editedItem.is_pnr = 0 ;
                }
                return editedItem ;
            };
            var prepTraitementAdjuvant = function(editedItem) {
                if(editedItem.dose_theorique) {
                    editedItem.dose_theorique = parseInt(editedItem.dose_theorique)
                }
                return editedItem ;
            };

            var prepPecTherapeutique = function(pecTherapeutique) {
                /*NETTOYAGE : on ne conserve que les champs qui correspondent à ce type de traitement thérapeutique*/
                var fieldsForTypes = {
                    "commonForAll" : ['editOrSave', 'id', 'participant_id', 'question_visite_def_id', 'etude_instance_id', 'visite_key', 'subtype', 'type_traitement'],
                    "chirurgie" : ['date_examen', 'type_chirurgie', 'has_curage_ganglionaire', 'has_chip_concomitante'],
                    "radiotherapie" : ['has_reduction_dose', 'has_report_arret_temporaire', 'date_debut', 'date_fin', 'dose_totale_gy'],
                    "chimioembolisation_PIPAC_CHIP_traitement_systemique" : ['date_debut', 'date_fin', 'nb_cures', 'has_reduction_dose', 'has_report_arret_temporaire', 'has_arret_definitif', 'voie_administration', 'classe_molecule', 'nom_specialite'],
                    "radiofrequence" : ['date_debut', 'date_fin'],
                    "endoscopie" : ['date_examen'],
                    "traitement_cible" : ['date_debut', 'date_fin', 'classe_molecule', 'nom_specialite'],
                } ;

                var typeTraitementChosen = "" ;
                if(["chimio_hyperthermique_intraperitoneale", "chimioembolisation", "chimio_intraperitoneale_pressurisee_par_aerosols", "chimiotherapie", "hormonotherapie", "traitement_cible"].indexOf(pecTherapeutique.type_traitement) !== -1) {
                    typeTraitementChosen = "chimioembolisation_PIPAC_CHIP_traitement_systemique" ;
                } else {
                    typeTraitementChosen = pecTherapeutique.type_traitement ;
                }

                Object.keys(pecTherapeutique).forEach(function (field) {
                    if(fieldsForTypes.commonForAll.indexOf(field) === -1 && (fieldsForTypes[typeTraitementChosen].indexOf(field) === -1)) {
                        pecTherapeutique[field] = null;
                    }
                });

                //on retire les classes qui ont été choisies puis désactivées
                for(var classe in pecTherapeutique.classe_molecule) {
                    if(pecTherapeutique.classe_molecule[classe] === 0) {
                        delete pecTherapeutique.classe_molecule[classe];
                    }
                }

                /* fin du NETTOYAGE */

                //gestion du format des dates
                pecTherapeutique.date_debut = pecTherapeutique.date_debut !== null ? moment(pecTherapeutique.date_debut).format('YYYY-MM-DD hh:mm:ss') : null;
                pecTherapeutique.date_examen = pecTherapeutique.date_examen !== null ? moment(pecTherapeutique.date_examen).format('YYYY-MM-DD hh:mm:ss') : null;
                pecTherapeutique.date_fin = pecTherapeutique.date_fin !== null ? moment(pecTherapeutique.date_fin).format('YYYY-MM-DD hh:mm:ss') : null;

                //transformation de la liste à choix multiples de classes de molécule en string
                pecTherapeutique.classe_molecule = pecTherapeutique.classe_molecule !== null ? JSON.stringify(pecTherapeutique.classe_molecule) : null;

                return pecTherapeutique ;
            };

            scope.editTraitement = function(editedItem) {
                editedItem = prepModificationsTherapeutiques(editedItem);
                editedItem = prepTraitementAdjuvant(editedItem);
                $http.post('participant-traitement', editedItem).then(function(response) {
                    editElementInArrayOfParticipant("participantTraitementsByQuestionVisiteId", response.data);
                    scope.checkAACAAP(editedItem);
                });
            };

            scope.editPriseencharge = function(editedItem) {
                $http.post('participant-priseencharge', editedItem).then(function(response) {
                    editElementInArrayOfParticipant("participantPriseenchargesByQuestionVisiteId", response.data);
                });
            };

            scope.editEicomplication = function(editedItem) {
                $http.post('participant-eicomplication', editedItem).then(function(response) {
                    editElementInArrayOfParticipant("participantEicomplicationsByQuestionVisiteId", response.data);
                });
            };

            scope.editEvaluationMaladie = function(editedItem) {
                $http.post('participant-evaluationmaladie', editedItem).then(function(response) {
                    editElementInArrayOfParticipant("participantEvaluationMaladieByQuestionVisiteId", response.data);
                });
            };

            scope.editPecTherapeutique = function(editedItem) {
                editedItem = prepPecTherapeutique(editedItem);
                $http.post('participant-pectherapeutique', editedItem).then(function(response) {
                    editElementInArrayOfParticipant("participantPecTherapeutiqueByQuestionVisiteId", response.data);
                });
            };

            /* ADDITION */

            var addElementInArrayOfParticipant = function(attribute, data) {
                if (!scope.participant[attribute]) {
                    scope.participant[attribute] = {};
                }
                if (!scope.participant[attribute][scope.questionVisite.id]) {
                    scope.participant[attribute][scope.questionVisite.id] = [];
                }
                scope.participant[attribute][scope.questionVisite.id].push(data);
                // -- 210223_6: LIve update de la valeur Auto
                if (!scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].auto) {
                    scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].auto = 0;
                }
                scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].auto++;
                scope.updateProgessOfLinkedTableQuestionnaire(attribute);
            };

            //si on était en "Rien à signaler", on réactive la question
            var ifQvInNdStateThenReactivate = function() {
                if(scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].nd) {
                    scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].nd = 0;
                    scope.onBlurWillSave(scope.visite, false, scope.questionVisite.id);
                }
            };

            scope.addTraitement = function(editedItem) {
                if(editedItem.nom_specialite_medicamenteuse !== null || editedItem.adjuvant_chimiotherapie !== null) {
                    editedItem = prepModificationsTherapeutiques(editedItem);
                    editedItem = prepTraitementAdjuvant(editedItem);
                    if (editedItem.medical_reason_textarea !== "") {
                        editedItem.raison_medicale = editedItem.medical_reason_textarea
                    }
                    $http.post('participant-traitement', editedItem).then(function (response) {
                        addElementInArrayOfParticipant("participantTraitementsByQuestionVisiteId", response.data);
                        ifQvInNdStateThenReactivate();
                        scope.checkAACAAP(editedItem);
                    });
                }
            };

            scope.addPriseencharge = function(editedItem) {
                $http.post('participant-priseencharge', editedItem).then(function(response) {
                    addElementInArrayOfParticipant("participantPriseenchargesByQuestionVisiteId", response.data);
                    ifQvInNdStateThenReactivate();
                });
            };

            scope.addEicomplication = function(editedItem) {
                $http.post('participant-eicomplication', editedItem).then(function(response) {
                    addElementInArrayOfParticipant("participantEicomplicationsByQuestionVisiteId", response.data);
                    ifQvInNdStateThenReactivate();
                });
            };

            scope.addEvaluationMaladie = function(editedItem) {
                $http.post('participant-evaluationmaladie', editedItem).then(function(response) {
                    addElementInArrayOfParticipant("participantEvaluationMaladieByQuestionVisiteId", response.data);
                    ifQvInNdStateThenReactivate();
                });
            };


            scope.addPecTherapeutique = function(editedItem) {
                if(editedItem.type_traitement !== null) {
                    editedItem = prepPecTherapeutique(editedItem);
                    $http.post('participant-pectherapeutique', editedItem).then(function (response) {
                        response.data.classe_molecule = JSON.parse(response.data.classe_molecule) ;
                        addElementInArrayOfParticipant("participantPecTherapeutiqueByQuestionVisiteId", response.data);
                        ifQvInNdStateThenReactivate();
                    });
                }
            };

            scope.linkedTableModaleController = function(linked_table_name) {
                switch (linked_table_name) {
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_TRAITEMENT:
                        return 'ctrlParticipantTraitement';
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PRISEENCHARGE:
                        return 'ctrlParticipantPriseencharge';
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EI_COMPLICATION:
                        return 'ctrlParticipantEicomplication';
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EVALUATIONMALADIE:
                        return 'ctrlParticipantEvaluationMaladie';
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PEC_THERAPEUTIQUE:
                        return 'ctrlParticipantPecTherapeutique';
                    default:
                        throw('Unable to return a ctrl on getModaleControllerForLinkedTable, unknown linkedTableType "' + linked_table_name + '"');
                }
            };
            scope.linkedTableEmptyObject = function(linked_table_name) {
                switch (linked_table_name) {
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_TRAITEMENT:
                        // -- empty traitement
                        return {
                            editOrSave: 'SAVE',
                            participant_id:                             scope.participant.id,
                            question_visite_def_id:                     scope.questionVisite.id,
                            etude_instance_id:                          scope.eti.id,
                            visite_key:                                 scope.visite.key,
                            subtype:                                    scope.questionMere.linkedTableSubtype,
                            order: null,
                            nom_specialite_medicamenteuse: null,
                            atc_specialite_medicamenteuse: null,
                            ucd13_specialite_medicamenteuse: null,
                            cis_specialite_medicamenteuse: null,
                            dose: null,
                            posologie_matin: "",
                            posologie_midi: "",
                            posologie_soir: "",
                            raison_medicale: null,
                            is_en_cours: null,
                            date_debut: null,
                            date_fin: null,
                            adjuvant_chimiotherapie: null,
                            adjuvant_nbre_cycle: null,
                            modifications_therapeutiques_resultat_changement: null,
                            modifications_therapeutiques_raison_medicale_changement: null,
                            modifications_therapeutiques_date_changement: null
                        };
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PRISEENCHARGE:

                        // -- empty priseencharge
                        return {
                            editOrSave: 'SAVE',
                            participant_id:                             scope.participant.id,
                            question_visite_def_id:                     scope.questionVisite.id,
                            etude_instance_id:                          scope.eti.id,
                            visite_key:                                 scope.visite.key,
                            subtype:                                    scope.questionMere.linkedTableSubtype,
                            order: null,

                            date_debut: null,
                            urgence_motif_lie_maladie: null,
                            urgence_motif_lie_traitement: null,
                            urgence_motif_autre: null,
                            urgence_issue_retour_domicile: null,
                            urgence_issue_hospitalisation: null,
                            urgence_issue_autre: null,

                            hospitalisation_motif_lie_maladie: null,
                            hospitalisation_motif_lie_traitement: null,
                            hospitalisation_motif_autre: null,
                            hospitalisation_issue_retour_domicile: null,
                            hospitalisation_issue_autre: null,

                            acte_externe_typeacte_imagerie: null,
                            acte_externe_typeacte_biologie: null,
                            acte_externe_typeacte_medecin: null,
                            acte_externe_typeacte_autre: null,
                            acte_externe_intitule: null,
                        };
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EI_COMPLICATION:

                        // -- empty priseencharge
                        return {
                            editOrSave: 'SAVE',
                            participant_id:                             scope.participant.id,
                            question_visite_def_id:                     scope.questionVisite.id,
                            etude_instance_id:                          scope.eti.id,
                            visite_key:                                 scope.visite.key,
                            subtype:                                    scope.questionMere.linkedTableSubtype,
                            order: null,

                            date_debut: null,
                            date_fin: null,

                            med_fiche3_ctc_meddra_code: null,
                            med_fiche3_ctc_meddra_terme: null,
                            med_fiche3_ctc_grade: null,
                            med_fiche3_ctc_action: null,
                            med_fiche3_ctc_evolution: null,

                            chir_fiche4_dindo_grade: null,
                            chir_fiche4_dindo_action: null,
                            chir_fiche4_dindo_evolution: null,
                        };
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EVALUATIONMALADIE:

                        // -- empty priseencharge
                        return {
                            editOrSave: 'SAVE',
                            participant_id:                             scope.participant.id,
                            question_visite_def_id:                     scope.questionVisite.id,
                            etude_instance_id:                          scope.eti.id,
                            visite_key:                                 scope.visite.key,
                            subtype:                                    scope.questionMere.linkedTableSubtype,
                            order: null,
                            examen: null,
                            date: null,
                            evaluation: null
                        };
                    case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PEC_THERAPEUTIQUE:
                        return {
                            editOrSave: 'SAVE',
                            participant_id:                             scope.participant.id,
                            question_visite_def_id:                     scope.questionVisite.id,
                            etude_instance_id:                          scope.eti.id,
                            visite_key:                                 scope.visite.key,
                            subtype:                                    scope.questionMere.linkedTableSubtype, //TODO vérifier ce champ ?

                            type_traitement: null,
                            nom_specialite: null,
                            date_debut: null,
                            date_fin: null,
                            date_examen: null,
                            type_chirurgie: null,
                            has_curage_ganglionaire: null,
                            has_chip_concomitante: null,
                            dose_totale_gy: null,
                            nb_cures: null,
                            has_reduction_dose: null,
                            has_report_arret_temporaire: null,
                            has_arret_definitif: null,
                            voie_administration: null,
                            classe_molecule: null
                        };
                    default:
                        throw('Unable to return a ctrl on getModaleControllerForLinkedTable, unknown linkedTableType "' + linked_table_name + '"');
                }
            };

            scope.isBtnRienASignalerDisplayed = function() {
                var btnHasToBeDisplayed ;
                if(scope.participant.participantValuesByQuestionVisiteId[scope.questionVisite.id].nd) {
                    btnHasToBeDisplayed = false ;
                } else {
                    switch (scope.questionMere.linked_table_name) {
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_TRAITEMENT:
                            btnHasToBeDisplayed = !scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id] || (Array.isArray(scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id]) && scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id].length === 0);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PRISEENCHARGE:
                            btnHasToBeDisplayed = !scope.participant.participantPriseenchargesByQuestionVisiteId[scope.questionVisite.id] || (Array.isArray(scope.participant.participantPriseenchargesByQuestionVisiteId[scope.questionVisite.id]) && scope.participant.participantPriseenchargesByQuestionVisiteId[scope.questionVisite.id].length === 0);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EI_COMPLICATION:
                            btnHasToBeDisplayed = !scope.participant.participantEicomplicationsByQuestionVisiteId[scope.questionVisite.id] || (Array.isArray(scope.participant.participantEicomplicationsByQuestionVisiteId[scope.questionVisite.id]) && scope.participant.participantEicomplicationsByQuestionVisiteId[scope.questionVisite.id].length === 0);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EVALUATIONMALADIE:
                            btnHasToBeDisplayed = !scope.participant.participantEvaluationMaladieByQuestionVisiteId[scope.questionVisite.id] || (Array.isArray(scope.participant.participantEvaluationMaladieByQuestionVisiteId[scope.questionVisite.id]) && scope.participant.participantEvaluationMaladieByQuestionVisiteId[scope.questionVisite.id].length === 0);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PEC_THERAPEUTIQUE:
                            btnHasToBeDisplayed = !scope.participant.participantPecTherapeutiqueByQuestionVisiteId[scope.questionVisite.id] || (Array.isArray(scope.participant.participantPecTherapeutiqueByQuestionVisiteId[scope.questionVisite.id]) && scope.participant.participantPecTherapeutiqueByQuestionVisiteId[scope.questionVisite.id].length === 0);
                            break;
                        default:
                            btnHasToBeDisplayed = false;
                    }
                }
                return btnHasToBeDisplayed ;
            };

            scope.updateProgessOfLinkedTableQuestionnaire = function(attribute){
                 console.log('****' + scope.questionVisite);
                // progress = 100 if at least 1 item, else 0
                scope.questionnaireVisite.updateProgress(scope.participant);
                // if(scope.participant[attribute][scope.questionVisite.id].length > 0 ){
                //     scope.questionnaireVisite.progression = 100;
                // }else{
                //     scope.questionnaireVisite.progression = 0;
                // }
            };

            // init progress
            // scope.updateProgessOfLinkedTableQuestionnaire("participantTraitementsByQuestionVisiteId");
            // ---- SIGNATURE COMMUNE          ------------------ //
            // --                                                 //

            scope.tableOnClickDelete = function(p) {
                var linked_table_name = scope.questionMere.linked_table_name;
                var text = 'Confirmer la suppression ?';
                if ($window.confirm(text))
                {
                    switch (linked_table_name) {
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_TRAITEMENT:
                            scope.deleteTraitement(p);
                        break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PRISEENCHARGE:
                            scope.deletePriseencharge(p);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EI_COMPLICATION:
                            scope.deleteEicomplication(p);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EVALUATIONMALADIE:
                            scope.deleteEvaluationMaladie(p);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PEC_THERAPEUTIQUE:
                            scope.deletePecTherapeutique(p);
                            break;
                        default:
                            throw('Unable to delete on tableOnClickDelete, unknown linkedTableType "' + linked_table_name + '"');
                    }

                }
            };


            scope.checkAACAAP = function(traitement) {
                if(traitement.subtype !== "recueil_initial" && traitement.subtype !== "traitement_initial"){
                    return;
                }
                const traitements_list = scope.participant.participantTraitementsByQuestionVisiteId[traitement.question_visite_def_id]

                var request = {
                    participant_id: traitement.participant_id,
                    eti_id: traitement.etude_instance_id,
                    is_any_aac: traitements_list.filter(function(t){
                        return t.atc_specialite_medicamenteuse && ["B01AA","B01AB","B01AE","B01AF","B01AX"].includes(t.atc_specialite_medicamenteuse.substring(0, 5));
                    }).length,
                    is_any_aap: traitements_list.filter(function(t){
                        return t.atc_specialite_medicamenteuse && ["B01AC"].includes(t.atc_specialite_medicamenteuse.substring(0, 5));
                    }).length
                };

                // mettre a jour les QV
                $http.post('participant-traitement/save-presence-aac-app', {request})
                    .then(function(response) {

                    }).catch(function (e) {

                    })

            };

            scope.tableOnClickEdit = function(p) {
                var modaleTemplate = scope.questionMere.formTemplateUrl;
                var linked_table_name = scope.questionMere.linked_table_name;

                //console.log('modaleTemplate ' + modaleTemplate);
                var scopeModal = scope.$new(true);

                p.editOrSave = 'EDIT';
                //console.log('object sent', p);
                var copyP = {};
                angular.copy(p, copyP);

                scope.modalInstance =
                    $uibModal.open({
                        templateUrl: modaleTemplate,
                        controller: scope.linkedTableModaleController(linked_table_name) ,// -- ctrl depend of the linked type !                       // -
                        windowClass: 'md-dialog',
                        scope: scopeModal,
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            eti: scope.eti,
                            questionVisite: scope.questionVisite,
                            participant: scope.participant,
                            questionMere: scope.questionMere,
                            linkedObject: copyP
                        }
                    });

                scope.modalInstance.result.then(function(editedItem) {
                    switch (linked_table_name) {
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_TRAITEMENT:
                            scope.editTraitement(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PRISEENCHARGE:
                            scope.editPriseencharge(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EI_COMPLICATION:
                            scope.editEicomplication(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EVALUATIONMALADIE:
                            scope.editEvaluationMaladie(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PEC_THERAPEUTIQUE:
                            scope.editPecTherapeutique(editedItem);
                            break;
                        default:
                            throw('Unable to edit on tableOnClickEdit, unknown linkedTableType "' + linked_table_name + '"');
                    }




                }, function() {
                    // copy back response into original object

                    // nothing done
                });
            };
            var traitements = [];



            scope.tableOnClickDuplicateTraitementWithCheckDate= function(linked_table_name) {

                scope.openModalSetFormCompletionDate().then(function () {
                    tableOnClickDuplicateTraitement();
                });

            };

            var tableOnClickDuplicateTraitement = _.debounce(function() {
                // console.log('debounced');

                if(traitements.length>0){

                    var promise = $http.post('participant-traitement/generate-for-therapeutic-modification', {traitements:traitements,qvId:scope.questionVisite.id,visite_key:scope.visite.key}).then(function(response)
                    {
                        if (!scope.participant.participantTraitementsByQuestionVisiteId) {
                            scope.participant.participantTraitementsByQuestionVisiteId = {};
                        }
                        if (!scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id]) {
                            scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id] = [];
                        }
                        scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id]=response.data;
                    }, function() {
                        // nothing done
                        console.log('action cancelled');

                    });
                    scope.tableTracker.addPromise(promise);
                }
            }, 1000);


            scope.tableOnClickCancelIsEmptyWithCheckDate = function(linked_table_name) {
                scope.openModalSetFormCompletionDate().then(function () {

                    scope.cancelNdForEditableAnswer();

                });
            };

            scope.tableOnClickIsEmptyWithCheckDate = function(linked_table_name) {

                scope.openModalSetFormCompletionDate().then(function () {

                    scope.setNdForEditableAnswer() ;

                });

            };

            scope.tableOnClickIsEmpty = function(linked_table_name) {

                var emptyItem = scope.linkedTableEmptyObject(linked_table_name);
                scope.setNdForEditableAnswer() ;

                //affichage du message de signalé comme vide
                if(linked_table_name === scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PEC_THERAPEUTIQUE) {
                    scope.participant.participantPecTherapeutiqueByQuestionVisiteId[scope.questionVisite.id] = [] ;
                } else if(linked_table_name === scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_TRAITEMENT) {
                    scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id] = [] ;
                } else if(linked_table_name === scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PRISEENCHARGE) {
                    scope.participant.participantPriseenchargesByQuestionVisiteId[scope.questionVisite.id] = [] ;
                } else if(linked_table_name === scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EI_COMPLICATION) {
                    scope.participant.participantEicomplicationsByQuestionVisiteId[scope.questionVisite.id] = [] ;
                } else if(linked_table_name === scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EVALUATIONMALADIE) {
                    scope.participant.participantEvaluationMaladieByQuestionVisiteId[scope.questionVisite.id] = [] ;
                } else {
                    console.error("linked table name '"+linked_table_name+"' is not currently related to any participant's list");
                }
            };

            scope.canDuplicateTraitement = function(){
                // no button for subtype other than modifications_therapeutiques
                var visiteNumber;
                if(scope.questionMere.linked_table_subtype !== "modifications_therapeutiques" /*&& scope.questionMere.linked_table_subtype !== "traitement_concomitant"*/){
                    return false;
                }
                var qmKeyFrom;
                var visiteKeyFrom;
                if(scope.questionMere.linked_table_subtype === "modifications_therapeutiques") {
                    /*la visite key est sous la forme PILOT1_V__V1 : on doit isoler le numéro de visite, et garder la référence de l'étude */
                    var visiteKeySplited = scope.visite.key.split("_");
                    visiteNumber = visiteKeySplited.pop(); //dernière entrée
                    var refEtude = visiteKeySplited[0]; //première entrée

                    // -- 210203_21 déterminer quel était la visite précédente pour recopier
                    var currentDisplayedVisiteKey = scope.visite.key;
                    var previousThanDisplayedVisiteKey = null;
                    _.each(scope.eti.etudedefArray.visitesOrderedKeys, function(vKey) {
                        if ( scope.participant.participantVisitesByVisiteKey[vKey] && vKey !== currentDisplayedVisiteKey) {
                            previousThanDisplayedVisiteKey = vKey;
                        }
                    });
                    // -- console.log('210203_21 : previousThanDisplayedVisiteKey : ' + previousThanDisplayedVisiteKey + '   ' + 'currentVisiteKey : ' + currentDisplayedVisiteKey);


                    switch (visiteNumber) {
                    case 'V1':
                        return false;
                    case 'V2':
                        // si
                        if (scope.participant.is_optimized && scope.$root.globalParams.moebiusMode) {
                            qmKeyFrom = refEtude + '_QM__TRAITEMENT_CONCILIATION_MEDICAMENTEUSE';
                        } else {
                            qmKeyFrom = refEtude + '_QM__TRAITEMENT_RECUEIL_INITIAL';
                        }
                        visiteKeyFrom = refEtude + '_V__V1';
                        break;
                    case 'V3':
                        qmKeyFrom = refEtude + '_QM__MODIFICATIONS_THERAPEUTIQUES';
                        visiteKeyFrom = refEtude + '_V__V2';
                        break;
                    case 'V4':
                        qmKeyFrom = refEtude + '_QM__MODIFICATIONS_THERAPEUTIQUES';
                        visiteKeyFrom = refEtude + '_V__V3';
                        break;
                    case 'V5':
                        qmKeyFrom = refEtude + '_QM__MODIFICATIONS_THERAPEUTIQUES';
                        visiteKeyFrom = refEtude + '_V__V4';
                        break;
                    case 'VF':

                        // -- 210203_21 déterminer quel était la visite précédente pour recopier
                        // -- si la visite avant la VF est la V1, on a un petit trick à gérer pour voir si on prends depuis initial ou depuis conciliation
                        if (previousThanDisplayedVisiteKey === refEtude + '_V__V1') {
                            if (scope.participant.is_optimized && scope.$root.globalParams.moebiusMode) {
                                qmKeyFrom = refEtude + '_QM__TRAITEMENT_CONCILIATION_MEDICAMENTEUSE';
                            } else {
                                qmKeyFrom = refEtude + '_QM__TRAITEMENT_RECUEIL_INITIAL';
                            }
                        }
                        // -- sinon, ben c'est forcément une source de type modification thérapeutique
                        else {
                            qmKeyFrom = refEtude + '_QM__MODIFICATIONS_THERAPEUTIQUES';
                        }
                        visiteKeyFrom = previousThanDisplayedVisiteKey;
                        break;
                    }
                }
                //get qv from which we duplicate
                var qvList = scope.visite.getQuestionVisiteForQuestionMereKeyList(qmKeyFrom);
                var qvFrom = qvList[visiteKeyFrom];
                //get traitements
                traitements = scope.participant.participantTraitementsByQuestionVisiteId[qvFrom.id];

                var canDuplicateTreatment = !_.isUndefined(traitements) && traitements.length>0 &&
                    (!scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id] || scope.participant.participantTraitementsByQuestionVisiteId[scope.questionVisite.id].length === 0);
                return canDuplicateTreatment ;
            };

            scope.tableOnClickAddWithCheckDate = function(linked_table_name) {

                scope.openModalSetFormCompletionDate().then(function () {

                    scope.tableOnClickAdd(linked_table_name);

                });

            };

            scope.tableOnClickAdd = _.debounce(function(linked_table_name) {
                var modaleTemplate = scope.questionMere.formTemplateUrl;

                var scopeModal = scope.$new(true);

                var linkedObject = scope.linkedTableEmptyObject(linked_table_name);

                /* définir le type de changement en "ajout d'un traitement" */
                if(scope.questionMere.linked_table_subtype === "modifications_therapeutiques") {
                    linkedObject.modifications_therapeutiques_resultat_changement = 3 ;
                }

                scope.modalInstance =
                    $uibModal.open({
                        templateUrl: modaleTemplate,
                        controller: scope.linkedTableModaleController(linked_table_name) ,// -- ctrl depend of the linked type !
                        windowClass: 'md-dialog',
                        scope: scopeModal,
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            eti: scope.eti,
                            questionVisite: scope.questionVisite,
                            participant: scope.participant,
                            questionMere: scope.questionMere,
                            linkedObject: linkedObject
                        }
                    });

                scope.modalInstance.result.then(function(editedItem) {

                    switch (linked_table_name) {
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_TRAITEMENT:
                            scope.addTraitement(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PRISEENCHARGE:
                            scope.addPriseencharge(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EI_COMPLICATION:
                            scope.addEicomplication(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_EVALUATIONMALADIE:
                            scope.addEvaluationMaladie(editedItem);
                            break;
                        case scope.constants.linked_types.NAMES_TO_VALUES.PARTICIPANT_PEC_THERAPEUTIQUE:
                            scope.addPecTherapeutique(editedItem);
                            break;
                        default:
                            throw('Unable to add on tableOnClickAdd, unknown linkedTableType "' + linked_table_name + '"');
                    }

                }, function() {
                    // copy back response into original object

                    // nothing done
                });
            }, 1000);


        }

        return {
            restrict: 'E',
            scope: {
                questionVisite:    '=mbsQuestionVisite',
                participant:       '=mbsParticipant',
                buildMode:         '=?buildMode',
                readOnly:         '=?readOnly',
                mbsOnDeleteQuestionVisite: '&',
                mbsOnMoveQuestionMereOfQr: '&',
            },
            link: link,

            require: '^mbsQrv',

            // templateUrl:'assets/templates/generic_templates/form/field/mbs_form_field_template.html',
            template: '<div ng-include="getContentUrl()"></div>'
        }
    }])
;


// WEBPACK FOOTER //
// ./resources/assets/js/directives/form.js